import React from 'react';
import styled from 'styled-components';
import Tippy from '@tippyjs/react';
import { FormattedMessage } from 'react-intl';
import { useLazyQuery } from '@apollo/client';
import { Badge, ProgressBar, TextStyle } from '@superops/ui-design-system';
import { Loader } from '@nile/components';
import { DisabledTag } from '@nile/components';
import { GET_TASK_LIST } from '@nile/graphql/src';
import { STATUS_MAP } from '@nile/projects/src/Constants';

const LoaderContainer = styled.div`
  width: 200px;
  height: 100px;
`;

const InfoPopupCardContainer = styled.div`
  padding: 12px;
  min-width: 250px;
  max-width: 350px;
  max-height: 200px;
  overflow: scroll;
  position: relative;
  line-break: anywhere;
`;

const NodescriptionContainer = styled.div`
  display: flex;
  padding: 5px 10px;
`;

function TaskCell(props) {
  const { cell } = props;
  const data = cell.row.original || cell.row.values;
  const { totalTasks, completedTasks } = data;

  const calculateProgress = (completed, total) => {
    if (!total) {
      return 0;
    }
    return Math.floor((completed / total) * 100);
  };

  const [
    getTask,
    { loading: taskLoading, error: taskError, data: taskData }
  ] = useLazyQuery(GET_TASK_LIST);

  const taskList = taskData?.getTasks?.tasks || [];

  return (
    <Tippy
      content={
        taskLoading ? (
          <LoaderContainer>
            <Loader />
          </LoaderContainer>
        ) : taskList?.length ? (
          <InfoPopupCardContainer className="white-to-grey-bg">
            {taskList?.map((task) => (
              <div className="flex g10 mb-20 space-between" key={task.taskId}>
                <div className="ellipsis" title={task.title}>
                  {task.title}
                </div>
                <Badge status={STATUS_MAP?.[task.status] || 'info'}>
                  <div className="nowrap">{task.status}</div>
                </Badge>
              </div>
            ))}
          </InfoPopupCardContainer>
        ) : (
          <NodescriptionContainer className="white-to-grey-bg">
            <FormattedMessage id="ticketlist.popup.nodescription.title" />
          </NodescriptionContainer>
        )
      }
      maxWidth={300}
      maxHeight={200}
      delay={100}
      duration={250}
      interactive
      placement="bottom-start"
      arrow={false}
      theme="light"
      offset={[0, 0]}
      onShow={() => {
        if (!totalTasks) {
          return;
        }
        getTask({
          variables: {
            module: 'PROJECT',
            listInfo: {
              condition: {
                joinOperator: 'AND',
                operands: [
                  {
                    attribute: 'project.projectId',
                    operator: 'is',
                    value: data?.projectId
                  }
                ]
              },
              sort: [
                {
                  attribute: 'taskOrder',
                  order: 'ASC',
                  emptyAtLast: true
                }
              ]
            }
          }
        });
      }}
    >
      <div className="progressBar flex actr w100 pr40">
        {totalTasks ? (
          <ProgressBar
            progress={calculateProgress(completedTasks, totalTasks)}
            size="small"
            customColor="#009F36"
          />
        ) : (
          ''
        )}
        {totalTasks ? (
          <div className="ml8 font-weight-500">
            {`${completedTasks}/${totalTasks}`}
          </div>
        ) : (
          <DisabledTag>NA</DisabledTag>
        )}
      </div>
    </Tippy>
  );
}

export default TaskCell;
